/*ěščřžýáíéúů*/
// SwiperJS pro testimonials
function initTestimonialSwiper() {
    const testimonialSwiper = new Swiper(".testimonial__content", {
        slidesPerView: 1,
        spaceBetween: 24,
        loop: true,
        autoplay: {
            delay: 10000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: ".buttons__next",
            prevEl: ".buttons__prev",
        },
        on: {
            slideChange() {
                // Reset všechny progress bary
                const allProgressBars = document.querySelectorAll(".testimonial__progress .progress-fill");
                allProgressBars.forEach((bar) => {
                    bar.style.width = "0%";
                });

                // Spusť animaci pro aktivní slide
                setTimeout(() => {
                    const activeSlide = document.querySelector(".swiper-slide-active");
                    if (activeSlide) {
                        const progressBar = activeSlide.querySelector(".testimonial__progress .progress-fill");
                        if (progressBar) {
                            progressBar.style.width = "100%";
                        }
                    }
                }, 100);
            },
            init() {
                // Spusť animaci pro první slide
                setTimeout(() => {
                    const activeSlide = document.querySelector(".swiper-slide-active");
                    if (activeSlide) {
                        const progressBar = activeSlide.querySelector(".testimonial__progress .progress-fill");
                        if (progressBar) {
                            progressBar.style.width = "100%";
                        }
                    }
                }, 100);
            },
        },
    });
}

// Inicializuj testimonial swiper
if (document.querySelector(".testimonial__content")) {
    initTestimonialSwiper();
}
